"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiDraggingComponent = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
/*
 * @internal
 */
function KpiDraggingComponent(_a) {
    var item = _a.item;
    return (react_1.default.createElement("div", { className: "move-kpi-placeholder" },
        react_1.default.createElement(sdk_ui_kit_1.ShortenedText, null, item.title)));
}
exports.KpiDraggingComponent = KpiDraggingComponent;
//# sourceMappingURL=KpiDraggingComponent.js.map